/**
 * @generated SignedSource<<99a20db37f4435d840f6aac21bbbcfa9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type updatePageValveFamilyQuery$variables = {
  valveFamilyId: string;
};
export type updatePageValveFamilyQueryVariables = updatePageValveFamilyQuery$variables;
export type updatePageValveFamilyQuery$data = {
  readonly valveFamily: {
    readonly id: string;
    readonly createdAt: any;
    readonly name: string;
    readonly manufacturer: {
      readonly id: string;
      readonly name: string;
    };
  } | null;
};
export type updatePageValveFamilyQueryResponse = updatePageValveFamilyQuery$data;
export type updatePageValveFamilyQuery = {
  variables: updatePageValveFamilyQueryVariables;
  response: updatePageValveFamilyQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "valveFamilyId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "valveFamilyId",
    "variableName": "valveFamilyId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updatePageValveFamilyQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ValveFamily",
        "kind": "LinkedField",
        "name": "valveFamily",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "manufacturer",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updatePageValveFamilyQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ValveFamily",
        "kind": "LinkedField",
        "name": "valveFamily",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "manufacturer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c1356c37abc5ece6bdfc87924a59d946",
    "id": null,
    "metadata": {},
    "name": "updatePageValveFamilyQuery",
    "operationKind": "query",
    "text": "query updatePageValveFamilyQuery(\n  $valveFamilyId: ID!\n) {\n  valveFamily(valveFamilyId: $valveFamilyId) {\n    id\n    createdAt\n    name\n    manufacturer {\n      __typename\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a760dfcbf79e5a67a9aea1b409dc7ca5";

export default node;
